// Common SQL data types for the Add Columns combobox. Seeded from the types the backend's
// parquet->SQL mapper and internal-asset flows produce. Free text is still allowed (data_type is a
// plain string server-side), so this is a suggestion list, not an enum.
export const SQL_COLUMN_TYPE_SUGGESTIONS: string[] = [
  "BIGINT",
  "INT",
  "SMALLINT",
  "TINYINT",
  "BIT",
  "DECIMAL(19,4)",
  "NUMERIC(18,2)",
  "FLOAT",
  "FLOAT(24)",
  "REAL",
  "MONEY",
  "VARCHAR(8000)",
  "VARCHAR(255)",
  "VARCHAR(MAX)",
  "NVARCHAR(4000)",
  "NVARCHAR(MAX)",
  "CHAR(1)",
  "TEXT",
  "DATE",
  "DATETIME2(7)",
  "DATETIME",
  "DATETIMEOFFSET(7)",
  "TIME(7)",
  "UNIQUEIDENTIFIER",
  "VARBINARY(MAX)",
];
